// src/apiConstants.js

const API_ROOT_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001/api';
export const API_BASE_URL = `${API_ROOT_URL.replace(/\/(banking|school)\/?$/, '').replace(/\/$/, '')}/banking`;

export const API_LOGIN = `${API_BASE_URL}/login`;
export const API_ME = `${API_BASE_URL}/me`;
export const API_BRANCHES = `${API_BASE_URL}/branches`;
export const API_EMPLOYEES = `${API_BASE_URL}/employees`;
export const API_ADD_EMPLOYEE = `${API_BASE_URL}/add-employee`;
export const API_UPDATE_EMPLOYEE = `${API_BASE_URL}/update-employee`;
export const API_DELETE_EMPLOYEE = `${API_BASE_URL}/delete-employee`;
export const API_EMPLOYEE_DETAIL = `${API_BASE_URL}/employee-detail`;
export const API_NEXT_EMPLOYEE_CODE = `${API_BASE_URL}/next-employee-code`;
export const API_VIEW_EMPLOYEE_DOCUMENT = `${API_BASE_URL}/view-employee-document`;

// Define the endpoints for different API calls
export const API_UPDATE_CENTER = `${API_BASE_URL}/update-center`;
export const API_CENTERS = `${API_BASE_URL}/centers`;
export const API_ADD_CENTER = `${API_BASE_URL}/add-center`;
export const API_DELETE_CENTER = `${API_BASE_URL}/delete-center`;
export const API_CENTER_DETAIL = `${API_BASE_URL}/center-detail`;


// Define the endpoints for different API calls for clients
export const API_GET_CLIENTS = `${API_BASE_URL}/get-client`;
export const API_UPDATE_CLIENT_STATUS = `${API_BASE_URL}/update-client-status`;
export const API_UPDATE_CLIENT_REPAYMENT_STATUS = `${API_BASE_URL}/update-client-repayment-status`;
export const API_ADD_CLIENT = `${API_BASE_URL}/add-client`;
export const API_ADD_CLIENTS_BULK = `${API_BASE_URL}/add-clients-bulk`;
export const API_UPDATE_CLIENT = `${API_BASE_URL}/update-client`;
export const API_DELETE_CLIENT = `${API_BASE_URL}/delete-client`;
export const API_VIEW_CLIENT_DOCUMENT = `${API_BASE_URL}/view-client-document`;
export const API_CLIENT_DETAIL = `${API_BASE_URL}/client-detail`;


// Define the endpoints for different API calls
export const API_ADD_LOAN_REPAYMENT = `${API_BASE_URL}/add-loan-repayment`;
export const API_GET_REPAYMENT_PAID = `${API_BASE_URL}/get-repayment-paid`;
export const API_REPAYMENT_STAFF = `${API_BASE_URL}/repayment-staff`;

// Define the endpoints for different API calls for loan management
export const API_GET_LOANS = `${API_BASE_URL}/get-loans`;
export const API_LOAN_PRODUCTS = `${API_BASE_URL}/loan-products`;
export const API_ADD_LOAN_PRODUCT = `${API_BASE_URL}/add-loan-product`;
export const API_UPDATE_LOAN_PRODUCT = `${API_BASE_URL}/update-loan-product`;
export const API_UPDATE_LOAN_PRODUCT_STATUS = `${API_BASE_URL}/update-loan-product-status`;
export const API_ADD_LOAN_DISBURSE = `${API_BASE_URL}/add-loan-disburse`;
export const API_ADD_LOAN_DISBURSE_MULTIPLE = `${API_BASE_URL}/add-loan-disburse-multiple`;
export const API_ADD_CLIENT_FOR_DISBURSEMENT = `${API_BASE_URL}/add-client-for-disbursement`;
export const API_ADD_CLIENTS_FOR_DISBURSEMENT_BULK = `${API_BASE_URL}/add-clients-for-disbursement-bulk`;
export const API_UPDATE_CLIENT_FOR_DISBURSEMENT = `${API_BASE_URL}/update-client-for-disbursement`;
export const API_DELETE_CLIENT_FOR_DISBURSEMENT = `${API_BASE_URL}/delete-client-for-disbursement`;
export const API_DISBURSEMENT_CLIENT_HISTORY = `${API_BASE_URL}/disbursement-client-history`;
export const API_ADD_LOAN_REPAYMENT_MULTIPLE = `${API_BASE_URL}/add-loan-repayment-multiple`;
export const API_MY_REPAYMENT_REQUESTS = `${API_BASE_URL}/my-repayment-requests`;
export const API_PENDING_REPAYMENT_REQUESTS = `${API_BASE_URL}/pending-repayment-requests`;
export const API_BRANCH_REPAYMENT_HISTORY = `${API_BASE_URL}/branch-repayment-history`;
export const API_APPROVE_REPAYMENT_REQUEST = `${API_BASE_URL}/approve-repayment-request`;
export const API_REJECT_REPAYMENT_REQUEST = `${API_BASE_URL}/reject-repayment-request`;
export const API_GET_CLIENTS_FOR_REPAYMENT = `${API_BASE_URL}/get-clients-for-repayment`;

// Define the endpoints for different API calls for report
export const API_GET_ADVANCE_REPAYMENT = `${API_BASE_URL}/get-advance-repayment`;
export const API_GET_REPAYMENT_REPORT = `${API_BASE_URL}/get-repayment-report`;
export const API_WEEKLY_OPERATIONS_SUMMARY = `${API_BASE_URL}/weekly-operations-summary`;
export const API_DASHBOARD_SUMMARY = `${API_BASE_URL}/dashboard-summary`;
export const API_OPERATIONS_REPORT = `${API_BASE_URL}/operations-report`;
export const API_OD_REPORT = `${API_BASE_URL}/od-report`;

export const API_MODULE_ACCESS_CATALOG = `${API_BASE_URL}/module-access-catalog`;
export const API_USERS = `${API_BASE_URL}/users`;
export const API_USER_DETAIL = `${API_BASE_URL}/user-detail`;
export const API_ADD_USER = `${API_BASE_URL}/add-user`;
export const API_UPDATE_USER = `${API_BASE_URL}/update-user`;
export const API_UPDATE_USER_STATUS = `${API_BASE_URL}/update-user-status`;
export const API_DELETE_USER = `${API_BASE_URL}/delete-user`;


